import React, { Suspense } from 'react';
import { LinearProgress } from '@mui/material';
import { match, Route, RouteProps, Switch } from 'react-router-dom';
import TIRouteProps from '../TIRouteProps';

type RouteTabsProps = {
  routes: TIRouteProps[];
  children?: React.ReactNode;
};

export const buildLinkPath = (
  pathMatch: match,
  dynamicPath?: string
): string | undefined => {
  const pathEndsWithSlash = pathMatch.path.endsWith('/');
  const urlEndsWithSlash = pathMatch.url.endsWith('/');

  return dynamicPath?.replace(
    pathMatch.path,
    `${pathMatch.url}${pathEndsWithSlash && !urlEndsWithSlash ? '/' : ''}`
  );
};

export const findTabValue = (
  tabRoutes: TIRouteProps[],
  currentPath: string,
  match: match
): number => {
  const tabIndex = tabRoutes.findIndex((route) => {
    const linkPath = buildLinkPath(
      match,
      Array.isArray(route.path) ? route.path[0] : route.path
    );

    return linkPath && route.exact === false
      ? currentPath.includes(linkPath)
      : linkPath === currentPath;
  });

  return tabIndex === -1 ? 0 : tabIndex;
};

export const RouteTabs: React.FC<RouteTabsProps> = ({
  routes,
  children
}: RouteTabsProps) => {
  return (
    <>
      <Suspense fallback={<LinearProgress />}>
        <Switch>
          {routes.map((route: RouteProps) => {
            return (
              <Route
                key={Array.isArray(route.path) ? route.path[0] : route.path}
                {...route}
              />
            );
          })}
          {children}
        </Switch>
      </Suspense>
    </>
  );
};

export default RouteTabs;
